/**
 * Znacznik czasu wejścia na paywall. Jedyny konsument: widget Visa Mobile
 * (`formIframeVisaMobile.mixin.js` przekazuje go jako `paywallStartTime` do `@bm/widget-connection`).
 * Pozostałe znaczniki (appStart, trxGetStart, …) zostały usunięte razem z akcją `logTimerStats`,
 * która jako jedyna je czytała.
 */
const state = {
  paywallView: null,
}
const mutations = {
  SET_TIMER_PAYWALL_VIEW(state, value) {
    state.paywallView = value
  },
}
const actions = {}
const getters = {}

export default {
  state,
  mutations,
  actions,
  getters,
}
